const MAX_FILE_SIZE = 50 * 1024 * 1024;

const ALLOWED_FILE_TYPES: Record<string, string[]> = {
  'application/pdf': ['.pdf'],
  'application/msword': ['.doc'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
  'application/vnd.ms-excel': ['.xls'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
  'text/csv': ['.csv'],
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/png': ['.png'],
  'image/gif': ['.gif'],
  'text/plain': ['.txt'],
  'application/json': ['.json'],
  'text/xml': ['.xml'],
  'application/xml': ['.xml'],
};

export interface ValidationResult {
  validFiles: File[];
  errors: string[];
}

export function validateFiles(files: File[], allowedExtensions: string): ValidationResult {
  const validFiles: File[] = [];
  const errors: string[] = [];

  const allowedExtList = allowedExtensions
    .toLowerCase()
    .split(',')
    .map((ext) => ext.trim());

  const filteredWhitelist: Record<string, string[]> = {};

  for (const [mimeType, extensions] of Object.entries(ALLOWED_FILE_TYPES)) {
    const matchingExtensions = extensions.filter(
      (ext) => allowedExtList.includes(ext) || allowedExtList.includes(ext.substring(1))
    );
    if (matchingExtensions.length > 0) {
      filteredWhitelist[mimeType] = matchingExtensions;
    }
  }

  for (const file of files) {
    if (file.size > MAX_FILE_SIZE) {
      errors.push(`${file.name}: Arquivo muito grande. Tamanho máximo: 50MB`);
      continue;
    }

    const allowedExtensionsForType = filteredWhitelist[file.type];
    if (!allowedExtensionsForType) {
      errors.push(`${file.name}: Tipo de arquivo não permitido`);
      continue;
    }

    const fileName = file.name.toLowerCase();
    const hasValidExtension = allowedExtensionsForType.some((ext) => fileName.endsWith(ext));

    if (!hasValidExtension) {
      errors.push(
        `${file.name}: Extensão não permitida. Use: ${allowedExtensionsForType.join(', ')}`
      );
      continue;
    }

    validFiles.push(file);
  }

  return { validFiles, errors };
}
